import cx from 'classnames';
import Image from 'next/image';
import 'photoswipe/dist/default-skin/default-skin.css';
import 'photoswipe/dist/photoswipe.css';
import { Gallery, Item } from 'react-photoswipe-gallery';

export default function LightboxImage({
  src,
  alt,
  width = 768,
  height = 1024,
  className,
  ...props
}) {
  return (
    <Gallery
      options={{
        bgOpacity: 0.7,
      }}
      shareButton={false}
      zoomButton={false}
    >
      <Item height={height} original={src} thumbnail={src} width={width}>
        {({ ref, open }) => (
          <div ref={ref} className={cx('relative h-full w-full', className)}>
            <Image alt={alt} src={src} onClick={open} {...props} />
          </div>
        )}
      </Item>
    </Gallery>
  );
}
